import { RootState } from '@box/redux/types';

export const exchangeRate = (state: RootState) =>
  state.loyalty.chart.exchangeRate;
export const points = (state: RootState) => state.loyalty.chart.points;
export const historyList = (state: RootState) =>
  state.loyalty.chart.historyList;
